export const de = {
  menu: {
    sectionNavigation: "Navigation",
    sectionAdministration: "Administration",
    navDashboard: "Mein Dashboard",
    navTraining: "Trainingsbereich",
    navTest: "Testbereich",
    navTeam: "Manager-Bereich",
    navSettings: "Einstellungen",
    navAdmin: "Admin-Bereich",
    navModuleEditing: "Modulbearbeitung",
    topLogout: "Abmelden",
    topAdminArea: "Admin-Bereich",
    themeEnableLight: "Hellmodus aktivieren",
    themeEnableDark: "Dunkelmodus aktivieren",
    notificationEmpty: "Aktuell keine offenen Aufgaben oder Warnungen.",
  },
  notifications: {
    expiredTitle: "Abgelaufene Trainings",
    expiredBody: "{count} Training(s) sind abgelaufen und müssen wiederholt werden.",
    expiringSoonTitle: "Trainings laufen bald ab",
    expiringSoonBody: "{count} Training(s) laufen in den nächsten 30 Tagen ab.",
    lowScoreTitle: "Quiz mit niedrigem Ergebnis",
    lowScoreBody: "{topic}: {pct}% – Modul erneut starten empfohlen.",
    testFailedTitle: "Wissenstest nicht bestanden",
    testFailedBody: "Letztes Ergebnis: {score}/{total}. Bitte Test erneut durchführen.",
    managerReminderTitle: "Erinnerung von {name}",
    managerReminderBody: "Bitte schließe deine offenen Sicherheits-Trainings ab.",
  },
  common: {
    loading: "Lädt…",
    imprint: "Impressum",
    user: "Benutzer",
    save: "Speichern",
    cancel: "Abbrechen",
    delete: "Löschen",
    edit: "Bearbeiten",
    back: "Zurück",
    yes: "Ja",
    no: "Nein",
    of: "von",
    all: "Alle",
    none: "–",
    search: "Suchen…",
    department: "Abteilung",
    departments: "Abteilungen",
    employee: "Mitarbeiter",
    employees: "Mitarbeiter",
    name: "Name",
    email: "E-Mail",
    status: "Status",
    actions: "Aktionen",
    csvExport: "CSV-Export",
    stable: "stabil",
    points: "Pkt.",
    measurePoints: "Messpunkten",
  },
  securityRadar: {
    title: "Dein Trainingsnetz",
    subtitle: "Die Darstellung zeigt deinen Fortschritt in den relevanten Trainingsbereichen.",
    scoreLabel: "Security-Score",
    legendValid: "Bestanden & gültig",
    legendSoon: "Läuft bald ab",
    legendDue: "Fällig oder offen",
  },
  dashboard: {
    welcome: "Glück auf, {name}!",
    greeting: {
      morning: "Guten Morgen, {name}!",
      day: "Guten Tag, {name}!",
      evening: "Guten Abend, {name}!",
      neutral: "Hallo, {name}!",
      casual: "Moin, {name}!",
      formal: "Guten Tag, {name}",
      formalNoName: "Guten Tag",
    },
    subtitle: "Hier siehst du deinen persönlichen Trainings-Fortschritt.",
    captionStart: "Leg los mit deinem ersten Training!",
    captionGoodStart: "Guter Start!",
    captionKeepGoing: "Am Ball bleiben!",
    captionStrong: "Starke Bilanz!",
    captionPro: "Security-Profi 🎖️",
    escalationExpiredTitle: "Pflicht-Trainings laufen ab – Erinnerung {sent} von {max}",
    escalationExpiredBody: "Deine Sicherheits-Trainings laufen demnächst ab oder sind bereits abgelaufen ({detail}). Bitte wiederhole sie zeitnah, sonst informieren wir die IT-Administration und der Internet-Zugriff kann eingeschränkt werden.",
    escalationExpiredDetailFallback: "Pflicht-Module",
    escalationExpiredCta: "Zu den Trainings",
    escalationTestTitle: "Sicherheitstest nicht bestanden – Erinnerung {sent} von {max}",
    escalationTestBody: "Du hast den Sicherheitstest mit {score}/{total} nicht bestanden. Bitte wiederhole das Training und den Test zeitnah. Solange der Test nicht bestanden ist, erhältst du regelmäßige Erinnerungen.",
    escalationTestCta: "Test wiederholen",
    trainingProgress: "Trainings-Fortschritt",
    modulesCompleted: "Module abgeschlossen",
    avgQuizScore: "Ø Quiz-Score",
    scoreVeryGood: "Sehr gut!",
    scoreGood: "Gut – weiter so!",
    scoreRoom: "Noch Verbesserungspotenzial",
    scoreNone: "Noch kein Quiz absolviert",
    totalTrainings: "Trainings insgesamt",
    securityStatus: "Security-Status",
    statusCertified: "Zertifiziert",
    statusInTraining: "In Ausbildung",
    statusNotStarted: "Nicht gestartet",
    allModulesPassed: "Alle Module bestanden",
    modulesStillOpen: "Noch {count} Modul(e) offen",
    pendingModules: "Offen",
    openBadge: "{open}/{total} offen",
    completedModules: "Abgeschlossen",
    expiredOn: "Abgelaufen am {date}",
    expiresOn: "Läuft ab {date} ({days} T.)",
    validUntil: "Gültig bis {date}",
    completedBadge: "✓ Abgeschlossen",
    statusGreenTitle: "Alles erledigt – stark!",
    statusGreenBody: "Alle deine Module sind gültig. Die nächste Wiederholung steht erst zum {date} an.",
    statusYellowTitle: "Bald fällig: {count} Modul(e) stehen für dieses Jahr an",
    statusYellowBody: "Dein bisheriger Abschluss gilt noch bis {date}. Wiederhol sie bis dahin, dann ist alles grün.",
    statusRedTitle: "Hey, da ist noch einiges offen",
    statusRedBody: "{count} Modul(e) sind noch nicht erledigt oder abgelaufen. Am besten gleich loslegen.",
    statusCta: "Jetzt weitermachen",
    validityTitle: "Wie lange gilt ein abgeschlossenes Modul?",
    validityYearEnd: "Jedes Modul, das du abschließt, gilt bis zum 31.12. des Folgejahres – egal, ob du es im Januar oder im Dezember machst.",
    validityMonths: "Jedes Modul, das du abschließt, gilt {months} Monate ab dem Tag, an dem du es bestanden hast.",
    validityExample: "Schließt du heute ({today}) ab, gilt das Modul bis {until}.",
    validityWhyYearEnd: "So frischen alle ihr Wissen im gleichen Rhythmus auf, und du hast immer mindestens ein volles Kalenderjahr Zeit.",
    validitySoon: "30 Tage vor Ablauf wird ein Modul gelb, danach rot. Einmal wiederholen, dann gilt es wieder.",
    topicsTitle: "Deine Themenfelder",
    topicDone: "{done}/{total} erledigt",
    moduleOpen: "Offen",
    moduleExpired: "Abgelaufen am {date}",
    moduleDue: "Fällig bis {date}",
    modulesCompletedYear: "Pflicht-Module {year} abgeschlossen",
    avgQuizScoreHint: "Zeigt den durchschnittlichen Score über alle absolvierten Quizze.",
    totalTrainingsHint: "Alle bestandenen Trainings seit deinem Start, Wiederholungen zählen mit.",
    validityNewRound: "Ab dem 01.01. jedes Jahres stehen alle Pflicht-Module wieder unter „Offen“ – auch wenn du sie im Vorjahr schon gemacht hast. Dein alter Abschluss bleibt bis 31.12. gültig, du hast also das ganze Jahr Zeit.",
    validityColorsYearEnd: "Gelb: für dieses Jahr noch zu wiederholen, der alte Abschluss gilt aber noch. Rot: noch nie gemacht oder abgelaufen.",
    colModule: "Modul",
    colScore: "Score",
    colCompletedAt: "Absolviert am",
    colValidUntil: "Gültig bis",
    colRenewed: "Bei Abschluss heute",
    renewHint: "Abschluss heute → gültig bis {date}",
    renewNoGain: "keine Verlängerung",
    renewDueHint: "Dieses Jahr wiederholen → gültig bis {date}",
    pendingSubtitle: "Was du in diesem Jahr noch erledigen musst – nach Themenbereichen.",
    completedSubtitle: "Deine Nachweise mit Datum und Gültigkeit. Im Jahr des Ablaufs steht ein Modul zusätzlich oben unter „Offen“.",
    openCount: "{count} offen",
    allDoneShort: "✓ erledigt",
    pendingEmpty: "Hier ist für dieses Jahr alles erledigt.",
    completedCount: "{count} abgeschlossen",
    completedEmpty: "Noch nichts abgeschlossen.",
    completedOn: "Absolviert {date}",
    moduleValid: "Gültig bis {date}",
    emptyState: "Noch keine Aktivitäten vorhanden.",
  },
  lernbereich: {
    title: "Trainingsbereich",
    subtitle: "Erweitertes Security-Lernangebot mit vielen Modulen, Praxisfällen und Quiz.",
    overallProgress: "Gesamtfortschritt",
    levelBadge: "Stufe {level}",
    modulesCompleted: "{done}/{total} Module abgeschlossen",
    badgeCompleted: "Abgeschlossen",
    badgeExpiringSoon: "Läuft bald ab",
    badgeExpired: "Abgelaufen",
    videoLabel: "{duration} Video",
    quizScore: "Quiz: {pct}%",
    expiredOn: "Abgelaufen am {date}",
    expiresOn: "Läuft ab am {date} (noch {days} Tage)",
    validUntil: "Gültig bis {date}",
    repeat: "Wiederholen",
    start: "Starten",
    otherModules: "Sonstiges",
    questionsSuffix: "{count} Fragen",
    completedOn: "✓ abgeschlossen am {date}",
    topicExpert: "Experte für dieses Thema",
  },
  demo: {
    badge: "Demo",
    heroTitle: "SHERLOX AWARE testen",
    heroSubtitle: "Probieren Sie ein vollständiges Lernmodul aus – inklusive Video, Lernblöcken und Quiz. In dieser Demo ist genau ein Modul freigeschaltet.",
    unlockedLabel: "In der Demo verfügbar",
    lockedLabel: "Nur in der Vollversion",
    lockedHint: "In der Demo nicht enthalten",
    fullVersionTitle: "Die Vollversion enthält außerdem",
    fullVersionPoint1: "Alle {count} Lernmodule für jede Mitarbeiterrolle",
    fullVersionPoint2: "Phishing-Simulationen für Ihr Team",
    fullVersionPoint3: "Echtzeit-Risiko-Dashboard für Admins",
    ctaSignIn: "Mit Microsoft anmelden",
    backToOverview: "← Zurück zur Demo-Übersicht",
    footerNote: "Demo-Modus – Ihr Fortschritt wird nicht gespeichert.",
    startModule: "Modul starten",
    noticeTitle: "Das ist eine kostenlose Demo",
    noticeText: "Sie testen hier ein einzelnes, vollständiges Lernmodul. Die komplette Plattform mit allen Modulen, Phishing-Simulationen und Risiko-Dashboard gibt es im Abo.",
    subscribeCta: "Abo anfragen",
    websiteCta: "Preise & Pakete ansehen",
    subscribeNote: "Schreiben Sie uns – wir melden uns mit allen Details und Preisen.",
    mailSubject: "SHERLOX AWARE – Abo-Anfrage",
    mailBody: "Hallo,\n\nich habe die SHERLOX AWARE Demo getestet und interessiere mich für ein Abo mit allen Modulen. Bitte senden Sie mir weitere Informationen und Preise.\n\nViele Grüße",
  },
  learningModuleVideo: {
    headingVideo: "Video",
    introVideo: "Sieh dir das Video an (ca. {duration}), bevor du mit den interaktiven Lernblöcken fortfährst.",
    germanAudioNote: "Die Tonspur ist derzeit nur auf Deutsch verfügbar.",
    done: "Video gesehen – Weiter zu den Lernblöcken →",
    forcedPending: "Dieses Video muss vollständig angesehen werden. Vorspulen ist nicht möglich.",
    forcedDone: "Video vollständig angesehen.",
    forcedButton: "Bitte zuerst das Video vollständig ansehen",
  },
  learningModulePdf: {
    loading: "Dokument wird geladen…",
    error: "Dokument konnte nicht geladen werden.",
    prevPage: "Zurück",
    nextPage: "Weiter",
    pageCounter: "Seite {page} von {total}",
    fullscreen: "Vollbild",
    exitFullscreen: "Vollbild verlassen",
    openNewTab: "↗ In neuem Tab öffnen",
  },
  learningModuleMedia: {
    imageError: "Bild konnte nicht geladen werden.",
    videoMissing: "Kein Video hinterlegt.",
    pageLoading: "Seite wird geladen…",
    pageOpenWindow: "↗ In eigenem Fenster öffnen",
    pageReload: "Neu laden",
    pageFullscreen: "Vollbild",
    pageExitFullscreen: "Vollbild verlassen",
    pageFallbackHint: "Bleibt der Rahmen leer oder zeigt er eine Anmeldeseite? Dann öffne die Seite oben mit „In eigenem Fenster öffnen“. Deine Schulung bleibt hier offen, dein Fortschritt geht nicht verloren.",
    pageNoUrl: "Kein Link hinterlegt.",
  },
  learningModule: {
    notFound: "Modul nicht gefunden",
    notAssignedTitle: "Dieses Modul ist dir nicht zugewiesen",
    notAssignedText: "Es gehört nicht zu deinem Schulungsplan oder ist für dein Unternehmen nicht freigeschaltet. Deine Module findest du im Trainingsbereich.",
    germanContentNote: "Dieses Modul liegt derzeit nur auf Deutsch vor.",
    backToTraining: "Zurück zum Trainingsbereich",
    trainingAreaShort: "Trainingsbereich",
    stepIntro: "Einführung",
    stepVideo: "Video",
    stepContent: "Inhalte",
    stepQuiz: "Quiz",
    stepCertificate: "Zertifikat",
    back: "Zurück",
    badgeModule: "Lernmodul",
    statVideo: "Video",
    statBlocks: "Lernblöcke",
    chapters: "{count} Kapitel",
    statQuizQuestions: "Quiz-Fragen",
    questionsCount: "{count} Fragen",
    passThresholdLabel: "Bestehensgrenze",
    startModule: "Modul starten →",
    blocksDone: "Lernblöcke abgeschlossen – zum Quiz →",
    next: "Weiter →",
    quizQuestion: "Quiz – Frage {current}/{total}",
    quizPreparing: "Fragen werden zusammengestellt…",
    quizLoadFailed: "Das Quiz konnte nicht gestartet werden. Bitte erneut versuchen.",
    quizLoadRetry: "Erneut versuchen",
    explanation: "Erklärung",
    scenarioLabel: "Szenario",
    scenarioPrompt: "Wähle eine Antwort um deine Reaktion zu testen",
    cascadePrompt: "Tippe auf eine Stufe, um Erklärung und Beispiel zu sehen",
    cascadeExample: "Beispiel",
    cascadeProgress: "{done} von {total} Stufen geöffnet",
    assignQuestionLabel: "Frage {current} von {total}",
    assignCorrect: "Richtig",
    assignWrong: "Nicht ganz",
    assignRevealHint: "Alle Fragen beantwortet – hier ist die vollständige Übersicht.",
    assignRevealButton: "Übersicht anzeigen",
    phishingIntro: "Diese E-Mail enthält {count} Warnsignale. Klicke auf die markierten Stellen, um die Gefahren aufzudecken. ({found}/{count} gefunden)",
    phishingReveal: "Klicken um aufzudecken",
    phishingFrom: "Von:",
    phishingTo: "An:",
    phishingSubject: "Betreff:",
    phishingRealLink: "echter Link",
    phishingAllFound: "✓ Alle {count} Warnsignale gefunden! Gut gemacht.",
    confirmAnswer: "Antwort bestätigen",
    nextQuestion: "Nächste Frage →",
    finishQuiz: "Quiz abschließen ✓",
    correctSuffix: "{score}/{total} richtig",
    gradeExcellent: "Ausgezeichnet",
    gradePassed: "Bestanden",
    gradeAlmost: "Knapp verfehlt",
    gradeFailed: "Nicht bestanden",
    doneWell: "Gut gemacht, {name}!",
    keepPracticing: "Weiter üben, {name}!",
    passBody: "Du hast das Modul „{title}“ erfolgreich abgeschlossen. Dein Fortschritt wurde gespeichert.",
    failBody: "Du hast die Mindestgrenze von {threshold}% noch nicht erreicht. Schau dir die Lernblöcke nochmal an – du schaffst das!",
    statCorrect: "Richtige Antworten",
    statResult: "Ergebnis",
    statStatus: "Status",
    statusPassed: "Bestanden ✓",
    statusFailed: "Nicht bestanden",
    completedModule: "Absolviertes Modul",
    saved: "✓ Gespeichert",
    saving: "Wird gespeichert…",
    saveFailedTitle: "Dein Ergebnis wurde nicht gespeichert",
    saveFailedText: "Der Server hat das Ergebnis nicht angenommen, das Modul zählt deshalb noch nicht als erledigt. Versuche es erneut. Klappt es weiter nicht, wiederhole das Quiz.",
    saveExpiredText: "Die Quiz-Sitzung ist abgelaufen, das Modul zählt deshalb noch nicht als erledigt. Bitte wiederhole das Quiz.",
    saveRetry: "Erneut speichern",
    certificatePdf: "Zertifikat als PDF",
    repeatBlocks: "Lernblöcke wiederholen",
    repeatQuiz: "Quiz wiederholen",
    allModules: "← Alle Module",
    certDownloaded: "Zertifikat heruntergeladen: {file}",
    downloadFailed: "Download fehlgeschlagen. Bitte erneut versuchen.",
    defaultFirstName: "Benutzer",
    defaultParticipant: "Teilnehmer",
    leaveWarning: "Dein Trainingsfortschritt ist noch nicht gespeichert und geht verloren, wenn du die Seite jetzt verlässt. Wirklich verlassen?",
  },
  test: {
    pageTitle: "Testbereich",
    pageSubtitle: "Teste dein Security-Wissen in einem vollständigen Wissenstest.",
    lastResult: "Letztes Ergebnis: {score}/{total} ({percentage}%)",
    passedShort: "Bestanden ✓",
    notPassedShort: "Nicht bestanden",
    knowledgeTest: "Security-Wissenstest",
    infoQuestions: "Fragen",
    infoTimeLimit: "Zeitlimit",
    infoMinutes: "15 Minuten",
    infoOpenModules: "Offene Module",
    infoAssigned: "Zugewiesen",
    infoTopicsCount: "{count} Themen",
    hintLabel: "Hinweis: ",
    hintBody: "Der Test wird aus deinen zugewiesenen Modulen zusammengestellt. Offene Module werden stärker gewichtet, die Fragen werden pro Versuch neu gemischt. Zum Bestehen sind mindestens 80% korrekte Antworten erforderlich.",
    certHintTitle: "Danach gibt es dein Zertifikat",
    certHintReady: "Bestehst du diesen Test, steht dein Abschlusszertifikat direkt zum Download bereit – alle zugewiesenen Module hast du schon abgeschlossen.",
    certHintOpen: "Bestehst du diesen Test, erhältst du dein Abschlusszertifikat, sobald auch deine {count} offenen Module abgeschlossen sind.",
    chipAssigned: "{count} zugewiesene Themen",
    chipOpen: "{count} noch offen",
    chipQuestions: "{count} Fragen im Test",
    preparing: "Test wird vorbereitet...",
    startPersonalized: "Personalisierten Test starten →",
    questionOf: "Frage {current} von {total}",
    answeredCount: "{count} beantwortet",
    selectAnswerFirst: "Bitte wählen Sie zuerst eine Antwort aus.",
    back: "← Zurück",
    submitTest: "Test abgeben ✓",
    next: "Weiter →",
    congrats: "Herzlichen Glückwunsch, {name}!",
    failedTitle: "Test nicht bestanden",
    passedBody: "Du hast den Security-Wissenstest erfolgreich bestanden.",
    failedBody: "Du hast die erforderlichen 80% leider nicht erreicht. Kein Problem – übe weiter!",
    correctOf: "{score}/{total} richtig",
    resultByTopic: "Ergebnis nach Thema",
    retake: "Test wiederholen",
    backToOverview: "Zurück zur Übersicht",
    startError: "Der Test konnte nicht gestartet werden. Bitte lade die Seite neu und versuche es erneut.",
    submitError: "Dein Ergebnis konnte nicht ausgewertet werden. Bitte lade die Seite neu und wiederhole den Test.",
  },
  certificate: {
    blockTitle: "Abschlusszertifikat",
    unlockedIntro: "Du hast alle zugewiesenen Module und den Wissenstest bestanden – dein Abschlusszertifikat steht bereit.",
    lockedTitle: "Zertifikat noch nicht freigeschaltet",
    lockedSubtitle: "Das Abschlusszertifikat erhältst du, sobald diese Voraussetzungen erfüllt sind:",
    reqModulesDone: "Alle zugewiesenen Module abgeschlossen",
    reqModulesOpen: "Noch {count} Modul(e) offen",
    reqTestPassed: "Wissenstest mit mindestens 80% bestanden",
    reqTestOpen: "Wissenstest noch nicht bestanden",
    downloadPdf: "Als PDF herunterladen",
    downloadPng: "Als Bild (PNG)",
    generating: "Zertifikat wird erstellt …",
    downloaded: "Zertifikat heruntergeladen: {file}",
    downloadError: "Zertifikat konnte nicht erstellt werden.",
    previewAlt: "Vorschau des Abschlusszertifikats",
    docTitle: "Zertifikat",
    brandBy: "by",
    docSubtitle: "Dieses Zertifikat bestätigt die erfolgreiche Teilnahme am AWARE by SHERLOX Schulungsprogramm.",
    issuedFor: "Ausgestellt für",
    programName: "AWARE Security-Awareness-Programm",
    labelProgram: "Programm",
    labelStatus: "Quiz-Status",
    valueStatus: "Bestanden",
    labelScore: "Quiz-Ergebnis",
    scoreSuffix: "richtig",
    labelCompletion: "Abschluss",
    valueCompletion: "Alle Module erfolgreich",
    labelIssued: "Ausstellungsdatum",
    labelValidUntil: "Gültig bis",
    labelCertId: "Zertifikats-ID",
    digitalCheck: "Digitale Prüfung",
    checkCodeLabel: "Prüfcode",
    verifyLabel: "Verifizierbar unter",
    focusTitle: "Schwerpunkte",
    validity: "Gültigkeit",
    completionCount: "Alle {count} Module abgeschlossen",
    verifyDomain: "aware.sherlox.de/zertifikat",
    labelTopic: "Thema",
    labelModule: "Modul",
    completionSingle: "Modul erfolgreich abgeschlossen",
    focusTitleModule: "Inhalt",
    moduleCertBtn: "Zertifikat",
    moduleCertBusy: "…",
    moduleCertError: "Zertifikat konnte nicht erstellt werden.",
    programIssuing: "Zertifikat wird registriert …",
    programError: "Das Abschlusszertifikat konnte nicht registriert werden. Bitte lade die Seite neu.",
    ready: "Thema abgeschlossen — Zertifikat verfügbar",
    readyIssued: "Zertifikat ausgestellt",
    moduleHint: "Alle {count} Module dieses Themas sind bestanden und gültig.",
    codeHint: "Prüfcode {code} · prüfbar auf aware.sherlox.de/zertifikat",
    issueBtn: "Zertifikat erstellen",
    downloadBtn: "Als PDF laden",
    busy: "Einen Moment …",
    issueError: "Zertifikat konnte nicht ausgestellt werden.",
    incomplete: "Es sind noch nicht alle Module dieses Themas bestanden oder gültig.",
  },
  reports: {
    title: "Berichte",
    subtitle: "Stell dir dein Dashboard aus Widgets selbst zusammen.",
    dataBasis: "Datenbasis",
    dataBasisSummary: "{users} Nutzer · {depts} Abt.",
    myAccount: "Mein Konto",
    activeUser: "Aktiver Nutzer",
    noDepartment: "Ohne Abteilung",
    noEmail: "Keine E-Mail hinterlegt",
    addWidget: "+ Widget hinzufügen",
    campaignsBtn: "Kampagnen",
    csvExport: "CSV Export",
    print: "Drucken",
    consentBlocked: "Benutzerdaten sind blockiert: Für User.Read.All fehlt ein Admin-Consent im Tenant.",
    loadingData: "Berichtsdaten werden geladen…",
    campaignFilterTitle: "Kampagnen in der Risikoübersicht",
    campaignFilterHint: "Deaktivierte Kampagnen fließen nicht in Klickrate und Phishing-Risiko ein.",
    allActive: "Alle aktiv",
    allOff: "Alle aus",
    noCampaigns: "Keine Kampagnen vorhanden.",
    unnamedCampaign: "Unbenannte Kampagne",
    sentSuffix: "{n} versendet",
    clicksSuffix: "{n} Klicks",
    emptyTitle: "Dein Dashboard ist leer",
    emptyBody: "Klick auf „+ Widget hinzufügen“, um KPIs, Diagramme oder Tabellen einzubauen.",
    moveUp: "Nach oben",
    moveDown: "Nach unten",
    edit: "Bearbeiten",
    remove: "Entfernen",
    noData: "Keine Daten.",
    noTrendData: "Noch keine Verlaufsdaten.",
    noRiskUsers: "Keine Risikonutzer.",
    noDepartments: "Keine Abteilungen.",
    total: "gesamt",
    lineRangeInfo: "Letzte {months} Monate · {points} Messpunkte",
    colName: "Name",
    colDepartment: "Abteilung",
    colClicks: "Klicks",
    colUsers: "Nutzer",
    colClickRate: "Klickrate",
    donutClicked: "Geklickt",
    donutNotClicked: "Nicht geklickt",
    donutCompleted: "Abgeschlossen",
    donutOpen: "Offen",
    riskLow: "Niedrig",
    riskMid: "Mittel",
    riskHigh: "Hoch",
    noPriorYear: "Kein Vorjahreswert verfügbar",
    priorYearTitle: "{label} vor 12 Monaten: {prior}%",
    vsPriorYear: "vs. Vorjahr ({prior}%)",
    priorYearDelta: "{sign}{diff} Pkt.",
    widgetEditTitle: "Widget bearbeiten",
    widgetAddTitle: "Widget hinzufügen",
    close: "Schließen",
    fieldType: "Typ",
    kindKpi: "KPI",
    kindDonut: "Kreis",
    kindBar: "Balken",
    kindLine: "Verlauf",
    kindTable: "Tabelle",
    fieldSize: "Größe",
    sizeSmall: "Klein (1/3)",
    sizeMedium: "Mittel (1/2)",
    sizeLarge: "Groß (voll)",
    fieldMetric: "Kennzahl",
    showPrevYear: "Vorjahresvergleich anzeigen",
    fieldDataSource: "Datenquelle",
    fieldSorting: "Sortierung",
    topN: "Top N (max 20)",
    fieldRange: "Zeitraum (Monate)",
    monthsOption: "{n} Monate",
    fieldContent: "Inhalt",
    rowCount: "Anzahl Zeilen (max 50)",
    add: "Hinzufügen",
    kpi: {
      clickRate: "Klickrate",
      completionRate: "Abgeschlossene Trainings",
      phishingRisk: "Phishing-Risiko",
      totalUsers: "Nutzer gesamt",
      atRiskCount: "Risikonutzer",
      totalDepartments: "Abteilungen",
      dataEntryRate: "Daten-Eingabe",
      notReportedRate: "Nicht gemeldet",
    },
    donut: {
      phishClickers: "Klicker vs. Nicht-Klicker",
      trainingsDone: "Trainings: erledigt vs. offen",
      riskBuckets: "Risikoverteilung",
    },
    bar: {
      departmentsByClickRate: "Abteilungen nach Klickrate",
      departmentsByCompletion: "Abteilungen nach Trainings-Quote",
    },
    line: {
      phishClickRate: "Klickrate im Verlauf",
      completionRate: "Trainings-Quote im Verlauf",
      avgRiskScore: "Ø Risiko-Score im Verlauf",
      avgTestScore: "Ø Test-Score im Verlauf",
    },
    table: {
      topRiskUsers: "Top Risikonutzer",
      topDepartments: "Top Abteilungen",
    },
    csv: {
      header: "SHERLOX AWARE — Dashboard-Export",
      asOf: "Stichtag",
      dataBasis: "Datenbasis",
      dataBasisValue: "{users} Mitarbeiter, {depts} Abteilungen",
      sectionKpis: "── KENNZAHLEN ──",
      phishingRisk: "Phishing-Risiko (0–100)",
      riskFormula: "Risiko = Daten-Eingabe × (1 + 0,5 × Nicht-Meldung/100) + 0,25 × max(0; Klickrate − Daten-Eingabe)",
      clickRate: "Klickrate (%)",
      dataEntryRate: "Daten-Eingabe (%)",
      notReportedRate: "Nicht gemeldet (%)",
      completionRate: "Trainingsabschluss (%)",
      riskyUsers: "Risikonutzer",
      sectionDepartments: "── ABTEILUNGEN ──",
      colDepartment: "Abteilung",
      colUsers: "Nutzer",
      colClickRate: "Klickrate (%)",
      sectionPriorYear: "── VORJAHRESVERGLEICH ──",
      colMetric: "Kennzahl",
      colCurrent: "Aktuell (%)",
      colTwelveMonthsAgo: "Vor 12 Monaten (%)",
      colDelta: "Δ (Pkt.)",
      rowClickRate: "Klickrate",
      rowTrainings: "Trainings",
    },
  },
  managerTeam: {
    title: "Mein Team",
    subtitle: "Behalte im Blick, welche deiner Mitarbeiter noch offene Trainingsmodule haben.",
    emptyTitle: "Noch kein Team zugewiesen",
    emptyBody: "Dir sind aktuell keine Mitarbeiter als Vorgesetztem zugeordnet. Das wird automatisch aus Microsoft Entra übernommen oder von einem Admin manuell gesetzt.",
    allDone: "Alle Module abgeschlossen",
    openModulesCount: "{count} offene Module",
    showDetails: "Details anzeigen",
    hideDetails: "Details ausblenden",
    openModulesTitle: "Offene Module",
    shellSubtitle: "Team",
    modeActive: "Manager-Modus aktiv",
    navOverview: "Team-Übersicht",
    navProgress: "Fortschritt",
    backToDashboard: "Zum Dashboard",
    remind: "Erinnern",
    remindTitle: "{name} erinnern",
    remindVia: "Erinnerung senden als",
    remindMail: "E-Mail + App-Notiz",
    remindNote: "Nur Notiz in der App",
    remindText: "Persönliche Nachricht (optional)",
    remindPlaceholder: "z. B. Bitte bis Freitag erledigen …",
    remindSend: "Senden",
    remindSentNote: "Notiz hinterlegt.",
    remindSentMail: "E-Mail + Notiz gesendet.",
    remindMailFailed: "Mailversand nicht möglich – Notiz wurde trotzdem hinterlegt.",
    remindFailed: "Konnte nicht gesendet werden.",
    notLoggedInBadge: "Hat sich noch nicht angemeldet",
    viaManager: "über {name}",
    wishTitle: "Dir fehlt eine Schulung?",
    wishBody: "Wünsch dir ein neues Thema für dein Team. Dein Wunsch geht per E-Mail aus deinem Postfach an SHERLOX – wir melden uns direkt bei dir.",
    wishButton: "Schulung wünschen",
    wishDialogTitle: "Neue Schulung wünschen",
    wishTopicLabel: "Thema der Schulung",
    wishTopicPlaceholder: "z. B. Umgang mit Gefahrstoffen",
    wishTextLabel: "Was soll die Schulung abdecken? (optional)",
    wishTextPlaceholder: "Für wen ist sie gedacht, was ist der Anlass, bis wann brauchst du sie?",
    wishHint: "Die E-Mail wird in deinem Namen verschickt. Antworten landen in deinem Postfach.",
    wishSend: "Wunsch senden",
    wishSent: "Danke – dein Wunsch ist unterwegs. Wir melden uns bei dir.",
    wishFailed: "Der Wunsch konnte nicht verschickt werden. Bitte versuch es später noch einmal.",
    remindAll: "Alle Offenen erinnern ({count})",
    remindAllTitle: "Offene Teammitglieder erinnern",
    remindAllIntro: "Diese Personen haben noch offene Module. Nimm heraus, wen du nicht erinnern möchtest.",
    remindAllSelected: "{count} von {total} ausgewählt",
    remindAllSelectAll: "Alle auswählen",
    remindAllSelectNone: "Keine auswählen",
    remindAllOpen: "{count} offen",
    remindAllNoteOnly: "nur Notiz in der App",
    remindAllSend: "{count} erinnern",
    remindAllDone: "{count} Personen erinnert.",
    remindAllDonePartial: "{count} Personen erinnert. Bei {failed} kam die E-Mail nicht an – die Notiz in der App steht trotzdem.",
    remindAllFailed: "Die Erinnerungen konnten nicht gesendet werden.",
    teamOf: "Team von {name}",
    coTitle: "Co-Manager",
    coBody: "Ein Co-Manager sieht dein Team so wie du, darf erinnern und bekommt die monatliche Team-Mail – zum Beispiel deine Vertretung.",
    coNone: "Du hast noch niemanden eingetragen.",
    coAddLabel: "E-Mail-Adresse der Person",
    coAddPlaceholder: "name@firma.de",
    coAdd: "Hinzufügen",
    coRemove: "Entfernen",
    coFor: "Du bist Co-Manager für {names} und siehst deshalb auch dieses Team.",
    coErrNotFound: "Diese Adresse gibt es in eurem Unternehmen nicht.",
    coErrNotEligible: "Diese Person kann kein Co-Manager werden – dafür braucht sie ein eigenes, aktives Konto.",
    coErrSame: "Das bist du selbst.",
    coErrLimit: "Mehr als {max} Co-Manager sind nicht möglich.",
    coErrGeneric: "Konnte nicht gespeichert werden. Bitte versuch es noch einmal.",
  },
  managerProgress: {
    title: "Team-Fortschritt",
    subtitle: "Abschlussquote deiner Mitarbeiter über alle zugewiesenen Module.",
    overallTitle: "Gesamtfortschritt des Teams",
    overallDone: "{done} von {total} Modulen abgeschlossen",
    memberDone: "{done}/{total} Modulen",
    membersTitle: "Mitarbeiter",
    noModules: "Keine Module zugewiesen",
    deadlineTitle: "Frist fürs Team",
    deadlineSubtitle: "Bis wann sollen alle offenen Module erledigt sein?",
    deadlineNone: "Keine Frist gesetzt",
    deadlineSave: "Frist speichern",
    deadlineClear: "Frist entfernen",
    deadlineRemaining: "noch {days} Tage",
    deadlineToday: "Frist ist heute",
    deadlineOver: "Frist überschritten",
    exemptExcluded: "{count} Person(en) ohne Schulungspflicht nicht mitgezählt",
    notLoggedInIncluded: "davon {count} Person(en) noch nicht angemeldet",
    notLoggedInExcluded: "{count} nicht angemeldete Person(en) ohne Gruppe nicht mitgezählt",
    subtitleHierarchy: "Enthält alle Mitarbeiter unter dir – auch die deiner Führungskräfte.",
    statusDone: "Abgeschlossen",
    statusOpen: "Offen",
    moduleFilterLabel: "Nach Modul filtern",
    moduleFilterAll: "Alle Module",
    overallTitleModule: "Fortschritt in diesem Modul",
    overallDoneModule: "{done} von {total} Personen haben das Modul abgeschlossen",
    managerYou: "du (direkt)",
    timeSuffix: "Uhr",
  },
  managerReports: {
    title: "Berichte & Nachweise",
    subtitle: "Wer aus deinem Team hat welche Schulung wann abgeschlossen – als Übersicht und als Nachweis für ein Audit.",
    asOf: "Stand: {date}.",
    printFilter: "Filter: {module}",
    exportExcel: "Nachweis exportieren (Excel)",
    print: "Drucken",
    kpiRate: "Schulungsquote",
    kpiRateHint: "{done} von {total} zugewiesenen Modulen erledigt",
    kpiComplete: "Vollständig geschult",
    kpiCompleteHint: "Personen, die alle ihre Module aktuell erledigt haben",
    kpiOpen: "Offene Module",
    kpiOpenHint: "Noch nicht bestanden oder abgelaufen",
    kpiExcluded: "Zählen nicht mit",
    kpiExcludedHint: "{exempt} müssen nicht teilnehmen, {notLoggedIn} nicht angemeldet und in keiner Gruppe",
    tabModules: "Nach Modul ({count})",
    tabPeople: "Nach Person ({count})",
    colModule: "Modul",
    colAssigned: "Zugewiesen",
    colDone: "Erledigt",
    colOpen: "Offen",
    colRate: "Quote",
    colPerson: "Person",
    colAccount: "E-Mail / Mitarbeiternummer",
    colDepartment: "Abteilung",
    colManager: "Vorgesetzte/r",
    colStatus: "Status",
    colCompletedAt: "Abgeschlossen am",
    colAsOf: "Stand",
    moduleLinkTitle: "Zeigt, wer dieses Modul erledigt hat und wer nicht",
    search: "Name, Abteilung oder Vorgesetzte suchen …",
    statusFilterAll: "Alle Personen",
    statusFilterDone: "Alle Module erledigt ({count})",
    statusFilterOpen: "Noch Module offen ({count})",
    statusFilterModuleDone: "Modul erledigt ({count})",
    statusFilterModuleOpen: "Modul offen ({count})",
    doneOf: "{done} von {total}",
    statusComplete: "Vollständig",
    statusOpenCount: "{count} offen",
    showModules: "Module zeigen",
    hideModules: "Module ausblenden",
    completedOn: "am {date}",
    emptyModules: "In dieser Auswahl ist niemandem ein Modul zugewiesen.",
    emptyPeople: "Keine Person passt zu dieser Auswahl.",
    sheetName: "Schulungsnachweis",
    fileName: "Schulungsnachweis",
  },
  trainingDuty: {
    statusLabel: "Schulungspflicht",
    required: "Muss teilnehmen",
    notRequired: "Muss nicht teilnehmen",
    notRequiredUntil: "Muss nicht teilnehmen bis {date}",
    notRequiredFrom: "Muss ab {date} nicht teilnehmen",
    notRequiredFromUntil: "Muss vom {from} bis {until} nicht teilnehmen",
    selfTitle: "Du musst aktuell nicht an den Schulungen teilnehmen",
    selfUntil: "Das gilt bis einschließlich {date}. Danach sind deine Module wieder Pflicht.",
    selfOpenEnded: "Das gilt bis auf Weiteres.",
    selfVoluntary: "Du kannst die Module trotzdem jederzeit freiwillig machen.",
    dialogTitle: "Schulungspflicht: {name}",
    untilLabel: "Gilt bis einschließlich",
    untilHint: "Leer lassen = unbefristet",
    setNotRequired: "Muss nicht teilnehmen",
    setRequired: "Muss wieder teilnehmen",
    change: "Ändern",
    dialogHint: "Solange das gilt, zählt die Person in keine Quote und bekommt keine Erinnerungen. Nach dem Datum ist die Schulung automatisch wieder Pflicht. Bitte keinen Grund notieren.",
    saveFailed: "Konnte nicht gespeichert werden.",
  },
  settings: {
    title: "Einstellungen",
    subtitle: "Persönliche Einstellungen für dein SHERLOX AWARE Konto.",
    tabAppearance: "Darstellung",
    tabLanguage: "Sprache",
    tabNotifications: "Benachrichtigungen",
    darkMode: "Dunkelmodus",
    darkOn: "Aktiviert",
    darkOff: "Deaktiviert – Systemeinstellung wird verwendet",
    menuLanguage: "Sprache der Oberfläche",
    menuLanguageHint: "Gilt für deinen kompletten Mitarbeiterbereich: Navigation, Dashboard, Trainingsbereich, Lernmodule, Quiz, Wissenstest und Berichte. Der Admin-Bereich bleibt deutsch.",
    langGerman: "Deutsch",
    langEnglish: "Englisch",
    languageSingleHint: "Für dein Unternehmen ist derzeit nur diese Sprache freigeschaltet.",
    greetingTitle: "Begrüßung",
    greetingHint: "So begrüßt dich SHERLOX AWARE oben auf deiner Startseite.",
    greetingPreview: "Vorschau",
    greetingModes: {
      classic: { label: "Glück auf", desc: "Der Bergmannsgruß mit deinem Vornamen" },
      timeOfDay: { label: "Nach Tageszeit", desc: "Guten Morgen, Guten Tag oder Guten Abend" },
      neutral: { label: "Neutral", desc: "Ein schlichtes „Hallo“ mit Vornamen" },
      casual: { label: "Locker", desc: "Ein kurzes „Moin“ mit Vornamen" },
      formal: { label: "Förmlich", desc: "„Guten Tag“ mit vollem Namen" },
      none: { label: "Keine Begrüßung", desc: "Die Startseite beginnt direkt mit deinem Fortschritt" },
    },
    greetingNonePreview: "(keine Begrüßung)",
    emailNotifs: "E-Mail-Benachrichtigungen",
    emailOn: "Aktiviert – du bekommst E-Mails zu neuen Aufgaben und Updates.",
    emailOff: "Deaktiviert – allgemeine Updates kommen nur in der App.",
    mandatoryTitle: "Pflicht-Erinnerungen kommen immer per E-Mail",
    mandatoryBody: "Erinnerungen zu ablaufenden oder fälligen Pflicht-Schulungen sowie nicht bestandenen Wissenstests bekommst du unabhängig von dieser Einstellung – das lässt sich nicht abschalten.",
  },
  sharedLogin: {
    title: "Anmeldung am Schulungsplatz",
    subtitle: "Melde dich mit deiner Mitarbeiternummer an, damit dein Schulungsfortschritt dir zugeordnet wird.",
    username: "Mitarbeiternummer",
    usernameHint: "So, wie sie auf deinem Ausweis oder Lohnzettel steht.",
    firstName: "Vorname",
    lastName: "Nachname",
    firstTimeHint: "Diese Nummer ist neu hier – bitte prüfe sie noch einmal. Dein Name dient nur dazu, dass deine Führungskraft sehen kann, wie weit du mit den Schulungen bist.",
    submitLogin: "Anmelden",
    submitFirstTime: "Loslegen",
    working: "Einen Moment…",
    errTaken: "Diese Mitarbeiternummer gehört zu einem anderen Schulungsplatz. Bitte wende dich an deine Ansprechperson.",
    errUsername: "Bitte nur Buchstaben, Ziffern, Punkt, Bindestrich oder Unterstrich verwenden.",
    errDisabled: "Dieser Zugang ist gesperrt. Bitte wende dich an deine Ansprechperson.",
    errSeats: "Es sind keine Lizenzplätze mehr frei. Bitte wende dich an deine Ansprechperson.",
    errSetup: "Sammelaccounts sind in dieser Umgebung noch nicht eingerichtet.",
    errGeneric: "Das hat nicht geklappt. Bitte noch einmal versuchen.",
    errName: "Bitte gib deinen Vor- und Nachnamen an.",
    errNotOnList: "Diese Mitarbeiternummer ist hier nicht eingetragen. Bitte wende dich an deine Ansprechperson.",
    loggedInAs: "Angemeldet als",
    logout: "Fertig – abmelden",
    logoutHint: "Bitte abmelden, wenn du fertig bist. Sonst lernt der Nächste auf deinen Namen.",
  },
};

export type TranslationDict = typeof de;

export const en: TranslationDict = {
  menu: {
    sectionNavigation: "Navigation",
    sectionAdministration: "Administration",
    navDashboard: "My dashboard",
    navTraining: "Training area",
    navTest: "Test area",
    navTeam: "Manager area",
    navSettings: "Settings",
    navAdmin: "Admin area",
    navModuleEditing: "Module editing",
    topLogout: "Sign out",
    topAdminArea: "Admin area",
    themeEnableLight: "Enable light mode",
    themeEnableDark: "Enable dark mode",
    notificationEmpty: "No open tasks or warnings right now.",
  },
  notifications: {
    expiredTitle: "Expired trainings",
    expiredBody: "{count} training(s) have expired and must be repeated.",
    expiringSoonTitle: "Trainings expiring soon",
    expiringSoonBody: "{count} training(s) expire within the next 30 days.",
    lowScoreTitle: "Quiz with a low score",
    lowScoreBody: "{topic}: {pct}% – we recommend restarting the module.",
    testFailedTitle: "Knowledge test not passed",
    testFailedBody: "Latest result: {score}/{total}. Please retake the test.",
    managerReminderTitle: "Reminder from {name}",
    managerReminderBody: "Please complete your open security trainings.",
  },
  common: {
    loading: "Loading…",
    imprint: "Legal notice",
    user: "User",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    back: "Back",
    yes: "Yes",
    no: "No",
    of: "of",
    all: "All",
    none: "–",
    search: "Search…",
    department: "Department",
    departments: "Departments",
    employee: "Employee",
    employees: "Employees",
    name: "Name",
    email: "E-mail",
    status: "Status",
    actions: "Actions",
    csvExport: "CSV export",
    stable: "stable",
    points: "pts",
    measurePoints: "data points",
  },
  securityRadar: {
    title: "Your training web",
    subtitle: "This chart shows your progress in the relevant training areas.",
    scoreLabel: "Security score",
    legendValid: "Passed & valid",
    legendSoon: "Expiring soon",
    legendDue: "Due or open",
  },
  dashboard: {
    welcome: "Glück auf, {name}!",
    greeting: {
      morning: "Good morning, {name}!",
      day: "Good afternoon, {name}!",
      evening: "Good evening, {name}!",
      neutral: "Hello, {name}!",
      casual: "Hi, {name}!",
      formal: "Good day, {name}",
      formalNoName: "Good day",
    },
    subtitle: "Here is your personal training progress.",
    captionStart: "Get started with your first training!",
    captionGoodStart: "Good start!",
    captionKeepGoing: "Keep it up!",
    captionStrong: "Strong record!",
    captionPro: "Security pro 🎖️",
    escalationExpiredTitle: "Mandatory training is expiring – reminder {sent} of {max}",
    escalationExpiredBody: "Your security training is about to expire or has already expired ({detail}). Please repeat it soon, otherwise we will inform IT administration and your internet access may be restricted.",
    escalationExpiredDetailFallback: "mandatory modules",
    escalationExpiredCta: "Go to training",
    escalationTestTitle: "Security test not passed – reminder {sent} of {max}",
    escalationTestBody: "You did not pass the security test with {score}/{total}. Please repeat the training and the test soon. As long as the test is not passed you will keep receiving reminders.",
    escalationTestCta: "Retake test",
    trainingProgress: "Training progress",
    modulesCompleted: "modules completed",
    avgQuizScore: "Avg. quiz score",
    scoreVeryGood: "Very good!",
    scoreGood: "Good – keep it up!",
    scoreRoom: "Room for improvement",
    scoreNone: "No quiz completed yet",
    totalTrainings: "Trainings in total",
    securityStatus: "Security status",
    statusCertified: "Certified",
    statusInTraining: "In training",
    statusNotStarted: "Not started",
    allModulesPassed: "All modules passed",
    modulesStillOpen: "{count} module(s) still open",
    pendingModules: "Open",
    openBadge: "{open}/{total} open",
    completedModules: "Completed",
    expiredOn: "Expired on {date}",
    expiresOn: "Expires {date} ({days} d.)",
    validUntil: "Valid until {date}",
    completedBadge: "✓ Completed",
    statusGreenTitle: "All done – great job!",
    statusGreenBody: "All your modules are valid. Your next refresher is not due until {date}.",
    statusYellowTitle: "Due soon: {count} module(s) are due this year",
    statusYellowBody: "Your previous completion is valid until {date}. Repeat them by then and everything is green.",
    statusRedTitle: "Hey, there is still some work to do",
    statusRedBody: "{count} module(s) are not done yet or have expired. Best to get started right away.",
    statusCta: "Continue now",
    validityTitle: "How long does a completed module stay valid?",
    validityYearEnd: "Every module you complete stays valid until 31 December of the following year – no matter whether you finish it in January or in December.",
    validityMonths: "Every module you complete stays valid for {months} months from the day you passed it.",
    validityExample: "If you complete it today ({today}), it stays valid until {until}.",
    validityWhyYearEnd: "That way everyone refreshes their knowledge on the same cycle, and you always get at least one full calendar year.",
    validitySoon: "30 days before it expires a module turns yellow, afterwards red. Repeat it once and it is valid again.",
    topicsTitle: "Your topic areas",
    topicDone: "{done}/{total} done",
    moduleOpen: "Open",
    moduleExpired: "Expired on {date}",
    moduleDue: "Due by {date}",
    modulesCompletedYear: "mandatory modules completed in {year}",
    avgQuizScoreHint: "Shows your average score across all quizzes you have taken.",
    totalTrainingsHint: "All trainings you have passed since you started, repeats included.",
    validityNewRound: "From 1 January each year all mandatory modules appear again under “Open” – even if you already completed them last year. Your previous completion stays valid until 31 December, so you have the whole year.",
    validityColorsYearEnd: "Yellow: still to be repeated this year, but your previous completion is still valid. Red: never completed or expired.",
    colModule: "Module",
    colScore: "Score",
    colCompletedAt: "Completed on",
    colValidUntil: "Valid until",
    colRenewed: "If completed today",
    renewHint: "Complete today → valid until {date}",
    renewNoGain: "no extension",
    renewDueHint: "Repeat this year → valid until {date}",
    pendingSubtitle: "What you still need to do this year – by topic area.",
    completedSubtitle: "Your records with date and validity. In the year it expires, a module also appears above under “Open”.",
    openCount: "{count} open",
    allDoneShort: "✓ done",
    pendingEmpty: "Everything in this area is done for this year.",
    completedCount: "{count} completed",
    completedEmpty: "Nothing completed yet.",
    completedOn: "Completed {date}",
    moduleValid: "Valid until {date}",
    emptyState: "No activity yet.",
  },
  lernbereich: {
    title: "Training area",
    subtitle: "Extended security learning offer with many modules, practical cases and quizzes.",
    overallProgress: "Overall progress",
    levelBadge: "{level} level",
    modulesCompleted: "{done}/{total} modules completed",
    badgeCompleted: "Completed",
    badgeExpiringSoon: "Expiring soon",
    badgeExpired: "Expired",
    videoLabel: "{duration} video",
    quizScore: "Quiz: {pct}%",
    expiredOn: "Expired on {date}",
    expiresOn: "Expires on {date} ({days} days left)",
    validUntil: "Valid until {date}",
    repeat: "Repeat",
    start: "Start",
    otherModules: "Other",
    questionsSuffix: "{count} questions",
    completedOn: "✓ completed on {date}",
    topicExpert: "Expert for this topic",
  },
  demo: {
    badge: "Demo",
    heroTitle: "Try SHERLOX AWARE",
    heroSubtitle: "Try a complete learning module – including video, learning blocks and quiz. This demo unlocks exactly one module.",
    unlockedLabel: "Available in the demo",
    lockedLabel: "Full version only",
    lockedHint: "Not included in the demo",
    fullVersionTitle: "The full version also includes",
    fullVersionPoint1: "All {count} learning modules for every employee role",
    fullVersionPoint2: "Phishing simulations for your team",
    fullVersionPoint3: "Real-time risk dashboard for admins",
    ctaSignIn: "Sign in with Microsoft",
    backToOverview: "← Back to demo overview",
    footerNote: "Demo mode – your progress is not saved.",
    startModule: "Start module",
    noticeTitle: "This is a free demo",
    noticeText: "You're trying a single, complete learning module here. The full platform with all modules, phishing simulations and the risk dashboard is available with a subscription.",
    subscribeCta: "Request a subscription",
    websiteCta: "View pricing & plans",
    subscribeNote: "Get in touch – we'll send you all the details and pricing.",
    mailSubject: "SHERLOX AWARE – subscription enquiry",
    mailBody: "Hello,\n\nI tried the SHERLOX AWARE demo and I'm interested in a subscription with all modules. Please send me more information and pricing.\n\nKind regards",
  },
  learningModuleVideo: {
    headingVideo: "Video",
    introVideo: "Watch the video (approx. {duration}) before you continue to the interactive lessons.",
    germanAudioNote: "The audio track is currently only available in German.",
    done: "Video watched – continue to the lessons →",
    forcedPending: "This video must be watched in full. Skipping ahead is not possible.",
    forcedDone: "Video watched in full.",
    forcedButton: "Please watch the video in full first",
  },
  learningModulePdf: {
    loading: "Loading document…",
    error: "Could not load document.",
    prevPage: "Back",
    nextPage: "Next",
    pageCounter: "Page {page} of {total}",
    fullscreen: "Fullscreen",
    exitFullscreen: "Exit fullscreen",
    openNewTab: "↗ Open in new tab",
  },
  learningModuleMedia: {
    imageError: "Image could not be loaded.",
    videoMissing: "No video provided.",
    pageLoading: "Loading page…",
    pageOpenWindow: "↗ Open in its own window",
    pageReload: "Reload",
    pageFullscreen: "Fullscreen",
    pageExitFullscreen: "Exit fullscreen",
    pageFallbackHint: "Frame empty or showing a sign-in page? Open the page above via “Open in its own window”. Your training stays open here and your progress is kept.",
    pageNoUrl: "No link provided.",
  },
  learningModule: {
    notFound: "Module not found",
    notAssignedTitle: "This module is not assigned to you",
    notAssignedText: "It is not part of your training plan or has not been enabled for your company. You will find your modules in the training area.",
    germanContentNote: "This module is currently only available in German.",
    backToTraining: "Back to the training area",
    trainingAreaShort: "Training area",
    stepIntro: "Introduction",
    stepVideo: "Video",
    stepContent: "Content",
    stepQuiz: "Quiz",
    stepCertificate: "Certificate",
    back: "Back",
    badgeModule: "Training module",
    statVideo: "Video",
    statBlocks: "Lessons",
    chapters: "{count} chapters",
    statQuizQuestions: "Quiz questions",
    questionsCount: "{count} questions",
    passThresholdLabel: "Pass mark",
    startModule: "Start module →",
    blocksDone: "Lessons complete – go to the quiz →",
    next: "Continue →",
    quizQuestion: "Quiz – question {current}/{total}",
    quizPreparing: "Preparing your questions…",
    quizLoadFailed: "The quiz could not be started. Please try again.",
    quizLoadRetry: "Try again",
    explanation: "Explanation",
    scenarioLabel: "Scenario",
    scenarioPrompt: "Choose an answer to test your reaction",
    cascadePrompt: "Tap a stage to see the explanation and an example",
    cascadeExample: "Example",
    cascadeProgress: "{done} of {total} stages opened",
    assignQuestionLabel: "Question {current} of {total}",
    assignCorrect: "Correct",
    assignWrong: "Not quite",
    assignRevealHint: "All questions answered – here is the full overview.",
    assignRevealButton: "Show the overview",
    phishingIntro: "This email contains {count} warning signs. Click the highlighted spots to reveal the dangers. ({found}/{count} found)",
    phishingReveal: "Click to reveal",
    phishingFrom: "From:",
    phishingTo: "To:",
    phishingSubject: "Subject:",
    phishingRealLink: "real link",
    phishingAllFound: "✓ All {count} warning signs found! Well done.",
    confirmAnswer: "Confirm answer",
    nextQuestion: "Next question →",
    finishQuiz: "Finish quiz ✓",
    correctSuffix: "{score}/{total} correct",
    gradeExcellent: "Excellent",
    gradePassed: "Passed",
    gradeAlmost: "Just missed",
    gradeFailed: "Not passed",
    doneWell: "Well done, {name}!",
    keepPracticing: "Keep practising, {name}!",
    passBody: "You have successfully completed the module “{title}”. Your progress has been saved.",
    failBody: "You haven't reached the pass mark of {threshold}% yet. Take another look at the lessons – you've got this!",
    statCorrect: "Correct answers",
    statResult: "Result",
    statStatus: "Status",
    statusPassed: "Passed ✓",
    statusFailed: "Not passed",
    completedModule: "Completed module",
    saved: "✓ Saved",
    saving: "Saving…",
    saveFailedTitle: "Your result was not saved",
    saveFailedText: "The server did not accept the result, so the module does not count as completed yet. Please try again. If it still fails, repeat the quiz.",
    saveExpiredText: "The quiz session has expired, so the module does not count as completed yet. Please repeat the quiz.",
    saveRetry: "Save again",
    certificatePdf: "Certificate as PDF",
    repeatBlocks: "Repeat lessons",
    repeatQuiz: "Repeat quiz",
    allModules: "← All modules",
    certDownloaded: "Certificate downloaded: {file}",
    downloadFailed: "Download failed. Please try again.",
    defaultFirstName: "User",
    defaultParticipant: "Participant",
    leaveWarning: "Your training progress has not been saved yet and will be lost if you leave this page now. Leave anyway?",
  },
  test: {
    pageTitle: "Test area",
    pageSubtitle: "Test your security knowledge in a full knowledge test.",
    lastResult: "Last result: {score}/{total} ({percentage}%)",
    passedShort: "Passed ✓",
    notPassedShort: "Not passed",
    knowledgeTest: "Security knowledge test",
    infoQuestions: "Questions",
    infoTimeLimit: "Time limit",
    infoMinutes: "15 minutes",
    infoOpenModules: "Open modules",
    infoAssigned: "Assigned",
    infoTopicsCount: "{count} topics",
    hintLabel: "Note: ",
    hintBody: "The test is assembled from your assigned modules. Open modules are weighted more heavily, and the questions are reshuffled for each attempt. A minimum of 80% correct answers is required to pass.",
    certHintTitle: "Your certificate comes right after",
    certHintReady: "Pass this test and your completion certificate is ready to download – you have already completed every assigned module.",
    certHintOpen: "Pass this test and you'll get your completion certificate as soon as your {count} open module(s) are completed too.",
    chipAssigned: "{count} assigned topics",
    chipOpen: "{count} still open",
    chipQuestions: "{count} questions in the test",
    preparing: "Preparing test...",
    startPersonalized: "Start personalized test →",
    questionOf: "Question {current} of {total}",
    answeredCount: "{count} answered",
    selectAnswerFirst: "Please select an answer first.",
    back: "← Back",
    submitTest: "Submit test ✓",
    next: "Continue →",
    congrats: "Congratulations, {name}!",
    failedTitle: "Test not passed",
    passedBody: "You have successfully passed the security knowledge test.",
    failedBody: "Unfortunately you didn't reach the required 80%. No problem – keep practising!",
    correctOf: "{score}/{total} correct",
    resultByTopic: "Result by topic",
    retake: "Retake test",
    backToOverview: "Back to overview",
    startError: "The test could not be started. Please reload the page and try again.",
    submitError: "Your result could not be evaluated. Please reload the page and retake the test.",
  },
  certificate: {
    blockTitle: "Completion certificate",
    unlockedIntro: "You have completed all assigned modules and passed the knowledge test – your completion certificate is ready.",
    lockedTitle: "Certificate not unlocked yet",
    lockedSubtitle: "You'll receive the completion certificate once these requirements are met:",
    reqModulesDone: "All assigned modules completed",
    reqModulesOpen: "{count} module(s) still open",
    reqTestPassed: "Knowledge test passed with at least 80%",
    reqTestOpen: "Knowledge test not passed yet",
    downloadPdf: "Download as PDF",
    downloadPng: "Download as image (PNG)",
    generating: "Generating certificate …",
    downloaded: "Certificate downloaded: {file}",
    downloadError: "The certificate could not be generated.",
    previewAlt: "Preview of the completion certificate",
    docTitle: "Certificate",
    brandBy: "by",
    docSubtitle: "This certificate confirms successful completion of the AWARE by SHERLOX training programme.",
    issuedFor: "Issued to",
    programName: "AWARE Security Awareness Programme",
    labelProgram: "Programme",
    labelStatus: "Quiz status",
    valueStatus: "Passed",
    labelScore: "Quiz result",
    scoreSuffix: "correct",
    labelCompletion: "Completion",
    valueCompletion: "All modules completed",
    labelIssued: "Issue date",
    labelValidUntil: "Valid until",
    labelCertId: "Certificate ID",
    digitalCheck: "Digital verification",
    checkCodeLabel: "Check code",
    verifyLabel: "Verify at",
    focusTitle: "Focus areas",
    validity: "Validity",
    completionCount: "All {count} modules completed",
    verifyDomain: "aware.sherlox.de/zertifikat",
    labelTopic: "Topic",
    labelModule: "Module",
    completionSingle: "Module completed successfully",
    focusTitleModule: "Content",
    moduleCertBtn: "Certificate",
    moduleCertBusy: "…",
    moduleCertError: "The certificate could not be generated.",
    programIssuing: "Registering certificate …",
    programError: "The completion certificate could not be registered. Please reload the page.",
    ready: "Topic completed — certificate available",
    readyIssued: "Certificate issued",
    moduleHint: "All {count} modules in this topic are passed and still valid.",
    codeHint: "Check code {code} · verifiable at aware.sherlox.de/zertifikat",
    issueBtn: "Create certificate",
    downloadBtn: "Download PDF",
    busy: "One moment …",
    issueError: "The certificate could not be issued.",
    incomplete: "Not all modules in this topic are passed or still valid.",
  },
  reports: {
    title: "Reports",
    subtitle: "Build your own dashboard from widgets.",
    dataBasis: "Data basis",
    dataBasisSummary: "{users} users · {depts} depts",
    myAccount: "My account",
    activeUser: "Active user",
    noDepartment: "No department",
    noEmail: "No email on file",
    addWidget: "+ Add widget",
    campaignsBtn: "Campaigns",
    csvExport: "CSV export",
    print: "Print",
    consentBlocked: "User data is blocked: admin consent for User.Read.All is missing in the tenant.",
    loadingData: "Loading report data…",
    campaignFilterTitle: "Campaigns in the risk overview",
    campaignFilterHint: "Disabled campaigns are excluded from the click rate and phishing risk.",
    allActive: "All active",
    allOff: "All off",
    noCampaigns: "No campaigns available.",
    unnamedCampaign: "Unnamed campaign",
    sentSuffix: "{n} sent",
    clicksSuffix: "{n} clicks",
    emptyTitle: "Your dashboard is empty",
    emptyBody: "Click “+ Add widget” to add KPIs, charts or tables.",
    moveUp: "Move up",
    moveDown: "Move down",
    edit: "Edit",
    remove: "Remove",
    noData: "No data.",
    noTrendData: "No trend data yet.",
    noRiskUsers: "No at-risk users.",
    noDepartments: "No departments.",
    total: "total",
    lineRangeInfo: "Last {months} months · {points} data points",
    colName: "Name",
    colDepartment: "Department",
    colClicks: "Clicks",
    colUsers: "Users",
    colClickRate: "Click rate",
    donutClicked: "Clicked",
    donutNotClicked: "Not clicked",
    donutCompleted: "Completed",
    donutOpen: "Open",
    riskLow: "Low",
    riskMid: "Medium",
    riskHigh: "High",
    noPriorYear: "No prior-year value available",
    priorYearTitle: "{label} 12 months ago: {prior}%",
    vsPriorYear: "vs. prior year ({prior}%)",
    priorYearDelta: "{sign}{diff} pts",
    widgetEditTitle: "Edit widget",
    widgetAddTitle: "Add widget",
    close: "Close",
    fieldType: "Type",
    kindKpi: "KPI",
    kindDonut: "Donut",
    kindBar: "Bars",
    kindLine: "Trend",
    kindTable: "Table",
    fieldSize: "Size",
    sizeSmall: "Small (1/3)",
    sizeMedium: "Medium (1/2)",
    sizeLarge: "Large (full)",
    fieldMetric: "Metric",
    showPrevYear: "Show year-over-year comparison",
    fieldDataSource: "Data source",
    fieldSorting: "Sorting",
    topN: "Top N (max 20)",
    fieldRange: "Range (months)",
    monthsOption: "{n} months",
    fieldContent: "Content",
    rowCount: "Number of rows (max 50)",
    add: "Add",
    kpi: {
      clickRate: "Click rate",
      completionRate: "Completed trainings",
      phishingRisk: "Phishing risk",
      totalUsers: "Total users",
      atRiskCount: "At-risk users",
      totalDepartments: "Departments",
      dataEntryRate: "Data entry",
      notReportedRate: "Not reported",
    },
    donut: {
      phishClickers: "Clickers vs. non-clickers",
      trainingsDone: "Trainings: done vs. open",
      riskBuckets: "Risk distribution",
    },
    bar: {
      departmentsByClickRate: "Departments by click rate",
      departmentsByCompletion: "Departments by completion rate",
    },
    line: {
      phishClickRate: "Click rate over time",
      completionRate: "Completion rate over time",
      avgRiskScore: "Avg. risk score over time",
      avgTestScore: "Avg. test score over time",
    },
    table: {
      topRiskUsers: "Top at-risk users",
      topDepartments: "Top departments",
    },
    csv: {
      header: "SHERLOX AWARE — dashboard export",
      asOf: "As of",
      dataBasis: "Data basis",
      dataBasisValue: "{users} employees, {depts} departments",
      sectionKpis: "── KEY FIGURES ──",
      phishingRisk: "Phishing risk (0–100)",
      riskFormula: "Risk = data entry × (1 + 0.5 × non-reporting/100) + 0.25 × max(0; click rate − data entry)",
      clickRate: "Click rate (%)",
      dataEntryRate: "Data entry (%)",
      notReportedRate: "Not reported (%)",
      completionRate: "Training completion (%)",
      riskyUsers: "At-risk users",
      sectionDepartments: "── DEPARTMENTS ──",
      colDepartment: "Department",
      colUsers: "Users",
      colClickRate: "Click rate (%)",
      sectionPriorYear: "── YEAR-OVER-YEAR ──",
      colMetric: "Metric",
      colCurrent: "Current (%)",
      colTwelveMonthsAgo: "12 months ago (%)",
      colDelta: "Δ (pts)",
      rowClickRate: "Click rate",
      rowTrainings: "Trainings",
    },
  },
  managerTeam: {
    title: "My team",
    subtitle: "Keep track of which of your team members still have open training modules.",
    emptyTitle: "No team assigned yet",
    emptyBody: "No employees are currently assigned to you as their manager. This is picked up automatically from Microsoft Entra or set manually by an admin.",
    allDone: "All modules completed",
    openModulesCount: "{count} open modules",
    showDetails: "Show details",
    hideDetails: "Hide details",
    openModulesTitle: "Open modules",
    shellSubtitle: "Team",
    modeActive: "Manager mode active",
    navOverview: "Team overview",
    navProgress: "Progress",
    backToDashboard: "Back to dashboard",
    remind: "Remind",
    remindTitle: "Remind {name}",
    remindVia: "Send reminder as",
    remindMail: "Email + in-app note",
    remindNote: "In-app note only",
    remindText: "Personal message (optional)",
    remindPlaceholder: "e.g. Please complete by Friday …",
    remindSend: "Send",
    remindSentNote: "Note saved.",
    remindSentMail: "Email + note sent.",
    remindMailFailed: "Email could not be sent – the note was saved anyway.",
    remindFailed: "Could not be sent.",
    notLoggedInBadge: "Has not signed in yet",
    viaManager: "via {name}",
    wishTitle: "Missing a training?",
    wishBody: "Request a new topic for your team. Your request is emailed from your mailbox to SHERLOX – we will get back to you directly.",
    wishButton: "Request a training",
    wishDialogTitle: "Request a new training",
    wishTopicLabel: "Training topic",
    wishTopicPlaceholder: "e.g. Handling hazardous substances",
    wishTextLabel: "What should the training cover? (optional)",
    wishTextPlaceholder: "Who is it for, what prompted it, and when do you need it?",
    wishHint: "The email is sent in your name. Replies arrive in your mailbox.",
    wishSend: "Send request",
    wishSent: "Thank you – your request is on its way. We will get back to you.",
    wishFailed: "The request could not be sent. Please try again later.",
    remindAll: "Remind everyone with open modules ({count})",
    remindAllTitle: "Remind team members with open modules",
    remindAllIntro: "These people still have open modules. Untick anyone you do not want to remind.",
    remindAllSelected: "{count} of {total} selected",
    remindAllSelectAll: "Select all",
    remindAllSelectNone: "Select none",
    remindAllOpen: "{count} open",
    remindAllNoteOnly: "in-app note only",
    remindAllSend: "Remind {count}",
    remindAllDone: "{count} people reminded.",
    remindAllDonePartial: "{count} people reminded. For {failed} the email could not be delivered – the in-app note was saved anyway.",
    remindAllFailed: "The reminders could not be sent.",
    teamOf: "Team of {name}",
    coTitle: "Co-managers",
    coBody: "A co-manager sees your team the way you do, can send reminders and receives the monthly team email – for example your deputy.",
    coNone: "You have not added anyone yet.",
    coAddLabel: "Email address of the person",
    coAddPlaceholder: "name@company.com",
    coAdd: "Add",
    coRemove: "Remove",
    coFor: "You are a co-manager for {names}, which is why you also see this team.",
    coErrNotFound: "This address does not exist in your company.",
    coErrNotEligible: "This person cannot become a co-manager – they need their own active account.",
    coErrSame: "That is you.",
    coErrLimit: "More than {max} co-managers are not possible.",
    coErrGeneric: "Could not be saved. Please try again.",
  },
  managerProgress: {
    title: "Team progress",
    subtitle: "Completion rate of your team members across all assigned modules.",
    overallTitle: "Overall team progress",
    overallDone: "{done} of {total} modules completed",
    memberDone: "{done}/{total} modules",
    membersTitle: "Team members",
    noModules: "No modules assigned",
    deadlineTitle: "Team deadline",
    deadlineSubtitle: "By when should all open modules be completed?",
    deadlineNone: "No deadline set",
    deadlineSave: "Save deadline",
    deadlineClear: "Remove deadline",
    deadlineRemaining: "{days} days left",
    deadlineToday: "Deadline is today",
    deadlineOver: "Deadline passed",
    exemptExcluded: "{count} person(s) without training requirement not counted",
    notLoggedInIncluded: "including {count} person(s) who have not signed in yet",
    notLoggedInExcluded: "{count} person(s) not signed in and in no group not counted",
    subtitleHierarchy: "Includes everyone below you – including the teams of your managers.",
    statusDone: "Completed",
    statusOpen: "Open",
    moduleFilterLabel: "Filter by module",
    moduleFilterAll: "All modules",
    overallTitleModule: "Progress in this module",
    overallDoneModule: "{done} of {total} people have completed the module",
    managerYou: "you (direct)",
    timeSuffix: "",
  },
  managerReports: {
    title: "Reports & records",
    subtitle: "Who on your team completed which training and when – as an overview and as a record for an audit.",
    asOf: "As of {date}.",
    printFilter: "Filter: {module}",
    exportExcel: "Export record (Excel)",
    print: "Print",
    kpiRate: "Completion rate",
    kpiRateHint: "{done} of {total} assigned modules completed",
    kpiComplete: "Fully trained",
    kpiCompleteHint: "People who have currently completed all of their modules",
    kpiOpen: "Open modules",
    kpiOpenHint: "Not yet passed, or expired",
    kpiExcluded: "Not counted",
    kpiExcludedHint: "{exempt} without training requirement, {notLoggedIn} not signed in and in no group",
    tabModules: "By module ({count})",
    tabPeople: "By person ({count})",
    colModule: "Module",
    colAssigned: "Assigned",
    colDone: "Completed",
    colOpen: "Open",
    colRate: "Rate",
    colPerson: "Person",
    colAccount: "Email / employee number",
    colDepartment: "Department",
    colManager: "Manager",
    colStatus: "Status",
    colCompletedAt: "Completed on",
    colAsOf: "As of",
    moduleLinkTitle: "Shows who has completed this module and who has not",
    search: "Search name, department or manager …",
    statusFilterAll: "All people",
    statusFilterDone: "All modules completed ({count})",
    statusFilterOpen: "Modules still open ({count})",
    statusFilterModuleDone: "Module completed ({count})",
    statusFilterModuleOpen: "Module open ({count})",
    doneOf: "{done} of {total}",
    statusComplete: "Complete",
    statusOpenCount: "{count} open",
    showModules: "Show modules",
    hideModules: "Hide modules",
    completedOn: "on {date}",
    emptyModules: "No one in this selection has a module assigned.",
    emptyPeople: "No person matches this selection.",
    sheetName: "Training record",
    fileName: "Training-record",
  },
  trainingDuty: {
    statusLabel: "Training requirement",
    required: "Training required",
    notRequired: "Training not required",
    notRequiredUntil: "Training not required until {date}",
    notRequiredFrom: "Training not required from {date}",
    notRequiredFromUntil: "Training not required from {from} to {until}",
    selfTitle: "You currently don't have to take part in the training",
    selfUntil: "This applies up to and including {date}. After that your modules are mandatory again.",
    selfOpenEnded: "This applies until further notice.",
    selfVoluntary: "You can still take the modules voluntarily at any time.",
    dialogTitle: "Training requirement: {name}",
    untilLabel: "Applies up to and including",
    untilHint: "Leave empty = no end date",
    setNotRequired: "Training not required",
    setRequired: "Training required again",
    change: "Change",
    dialogHint: "While this applies, the person is not counted in any rate and receives no reminders. After the date the training automatically becomes mandatory again. Please do not note a reason.",
    saveFailed: "Could not be saved.",
  },
  settings: {
    title: "Settings",
    subtitle: "Personal settings for your SHERLOX AWARE account.",
    tabAppearance: "Appearance",
    tabLanguage: "Language",
    tabNotifications: "Notifications",
    darkMode: "Dark mode",
    darkOn: "Enabled",
    darkOff: "Disabled – system setting is used",
    menuLanguage: "Interface language",
    menuLanguageHint: "Applies to your entire employee area: navigation, dashboard, training area, learning modules, quizzes, knowledge test and reports. The admin area stays in German.",
    langGerman: "German",
    langEnglish: "English",
    languageSingleHint: "Only this language is currently enabled for your company.",
    greetingTitle: "Greeting",
    greetingHint: "How SHERLOX AWARE greets you at the top of your home page.",
    greetingPreview: "Preview",
    greetingModes: {
      classic: { label: "Glück auf", desc: "The traditional miners' greeting with your first name" },
      timeOfDay: { label: "By time of day", desc: "Good morning, good afternoon or good evening" },
      neutral: { label: "Neutral", desc: "A simple “Hello” with your first name" },
      casual: { label: "Casual", desc: "A short “Hi” with your first name" },
      formal: { label: "Formal", desc: "“Good day” with your full name" },
      none: { label: "No greeting", desc: "Your home page starts right with your progress" },
    },
    greetingNonePreview: "(no greeting)",
    emailNotifs: "Email notifications",
    emailOn: "Enabled – you'll receive emails about new tasks and updates.",
    emailOff: "Disabled – general updates only appear in the app.",
    mandatoryTitle: "Mandatory reminders are always sent by email",
    mandatoryBody: "You'll receive reminders about expiring or due mandatory training and failed knowledge tests regardless of this setting – this cannot be turned off.",
  },
  sharedLogin: {
    title: "Sign in at this training station",
    subtitle: "Sign in with your employee number so your training progress is recorded for you.",
    username: "Employee number",
    usernameHint: "Exactly as it appears on your badge or payslip.",
    firstName: "First name",
    lastName: "Last name",
    firstTimeHint: "This number is new here – please double-check it. Your name is only used so your manager can see how far along you are with the training.",
    submitLogin: "Sign in",
    submitFirstTime: "Get started",
    working: "One moment…",
    errTaken: "That employee number belongs to a different training station. Please ask your contact person.",
    errUsername: "Please use letters, digits, dot, hyphen or underscore only.",
    errDisabled: "This access is blocked. Please ask your contact person.",
    errSeats: "No licence seats are available. Please ask your contact person.",
    errSetup: "Shared accounts are not set up in this environment yet.",
    errGeneric: "That did not work. Please try again.",
    errName: "Please enter your first and last name.",
    errNotOnList: "This employee number is not on the list for this station. Please ask your contact person.",
    loggedInAs: "Signed in as",
    logout: "Done – sign out",
    logoutHint: "Please sign out when you are finished. Otherwise the next person learns under your name.",
  },
};
